import React from 'react';
import { Checkbox, Card } from 'antd';
import { Controller, useFormContext } from 'react-hook-form';

const ActivityOptions = () => {
  const { control } = useFormContext();

  return (
    <Card className="card">
      <div>
        <Controller
          control={control}
          name="shouldMoveOutOfPromotion"
          render={({ field: { value, onChange } }) => {
            return (
              <Checkbox
                checked={value}
                onChange={e => onChange(e.target.checked)}
              >
                Move mails out of promotion
              </Checkbox>
            );
          }}
        />
      </div>

      <div>
        <Controller
          control={control}
          name="shouldMoveOutOfSpam"
          render={({ field: { value, onChange } }) => {
            return (
              <Checkbox
                checked={value}
                onChange={e => onChange(e.target.checked)}
              >
                Move mails out of spam
              </Checkbox>
            );
          }}
        />
      </div>

      <div>
        <Controller
          control={control}
          name="shouldEngageNewsletters"
          render={({ field: { value, onChange } }) => {
            return (
              <Checkbox
                checked={value}
                onChange={e => onChange(e.target.checked)}
              >
                Engage newsletters
              </Checkbox>
            );
          }}
        />
      </div>
    </Card>
  );
};

export default ActivityOptions;
